<template>
  <div class="xTable" v-loading="loading">
    <AppTable
        v-bind="$attrs"
        ref="xTable"
        v-on="$listeners"
        :firstColumn="firstColumn"
        :tableSize="tableSize"
        :iconView="iconView"
        :maxHeight="maxHeight"
        :dataSource="dataSource"
        :editRowId="editRowId"
        :row-key="rowKey"
        @row-click="rowClick"
    />
    <div class="pagenation">
      <AppPagination
          v-if="hasPagination && !loading"
          :pageSize="pagination.pageSize"
          :total="pagination.total"
          :currentPage="pagination.currentPage"
          :layout="layout"
          @pageChange="pageChange"
      />
    </div>
  </div>
</template>

<script>
import AppTable from "../ui/AppTable";
import AppPagination from "../ui/AppPagination/AppPagination";

export default {
  name: "XTable",
  components: {AppPagination, AppTable},
  props: {
    rowKey: {
      default: "id",
    },
    api: {
      type: Function,
      default: () => {
      },
    },
    state: {
      type: Object,
      default() {
        return {};
      },
    },
    firstColumn: {
      type: Boolean,
      default: false,
    },
    hasPagination: {
      type: Boolean,
      default: true,
    },
    iconView: {
      type: Number,
      default: 3,
    },
    maxHeight: {
      type: Number,
      default: 550,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tableSize: {
      type: String,
      default: "medium",
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
    },
    editRowId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    dataSource() {
      return (
          this.state.results ||
          this.state.data ||
          this.state.lessonContentList ||
          []
      );
    },
    pagination() {
      // if (
      //   this.dataSource &&
      //   this.dataSource.length < 1 &&
      //   this.state.page !== 1 &&
      //   this.state.page * this.state.size > this.state.total
      // ) {
      //   return {
      //     currentPage: this.state.page,
      //     pageSize: this.state.size,
      //     total: this.state.total + 1,
      //   };
      // } else {
      //   return {
      //     currentPage: this.state.page || 1,
      //     pageSize: this.state.size || 10,
      //     total: this.state.total || 0,
      //   };
      // }
      return {
        currentPage: this.state.page,
        pageSize: this.state.size,
        total: this.state.total,
      };
    },
  },
  methods: {
    rowClick(row) {
      this.$emit("row-click", row)
    },
    async getData(page) {
      await this.api({
        page: page ? page.page : this.state.page || 1,
        size: page ? page.size : this.state.size || 10,
      });
    },
    pageChange(page) {
      this.getData(page);
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.xTable {
  .pagenation {
    text-align: center;
  }
}
</style>
